<template>
  <div id="last_area">
    <!-- 新規申込の場合 -->
    <div class="message_area" v-if="getHasRegistration === 'new'">
      お申込みが完了しました。<br />
      タブレットを担当者へお渡しください。
    </div>
    <!-- 追加申込の場合 -->
    <div class="message_area" v-if="getHasRegistration === 'add'">
      追加の手続きが完了しました。<br />
      タブレットを担当者へお渡しください。
    </div>
    <!-- 変更申込の場合 -->
    <div class="message_area" v-if="getHasRegistration === 'change'">
      内容変更の手続きが完了しました。<br />
      タブレットを担当者へお渡しください。
    </div>

    <!-- 新規申込の場合 -->
    <div class="next" v-if="getHasRegistration === 'new'">
      <el-button type="primary" icon="el-icon-arrow-right" @click="homeTransition">Topページへ戻る</el-button>
    </div>
    <!-- 追加申込の場合 -->
    <div class="next" v-if="getHasRegistration === 'add'">
      <el-button type="primary" icon="el-icon-arrow-right" @click="homeTransition">Topページへ戻る</el-button>
    </div>
    <!-- 変更申込の場合 -->
    <div class="next" v-if="getHasRegistration === 'change'">
      <el-button type="primary" icon="el-icon-arrow-right" @click="listTransition">ご契約情報一覧へ戻る</el-button>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
export default {
  data() {
    return {
      next: true,
    }
  },
  computed: {
    ...mapGetters({
      getHasRegistration: 'status/getHasRegistration',
      contractId: 'status/getHasContractId',
      getOption: 'productInput/getOption',
    })
  },
  mounted() {
    this.$emit('page', 'form-done')
    this.updateHasCancel(false)
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== 'form-upload') {
      next()
    } else {
      this.transitionClearCache('/')
    }
  },
  methods: {
    ...mapActions({
      updateHasCancel: 'status/updateHasCancel'
    }),
    homeTransition() {
      this.transitionClearCache('/')
      //this.transitionSame('top')
    },
    listTransition() {
      this.transitionClearCache('/list')
    },
  }
}
</script>

<style lang="scss" scoped>
.message_area {
  padding: 15px;
  border: 2px solid #eee;
  text-align: center;
}

.next {
  margin-top: 40px;
  text-align: center;
  .el-button {
    border-radius: 0;
    padding-left: 30px;
    padding-right: 30px;
  }
}

.aplus-request {
  margin-top:30px;
}

.el-receiptDialog {
  &__mainTitle {
    font-size: 16px;
    font-weight: bold;
  }
  &__btnText {
    font-size: 12px;
    margin-top: 1rem;
    white-space: pre-wrap;
    line-height: 1.5;
  }
  &__btnStrongText {
    font-size: 20px;
  }
  &__strongBtn {
    display: block;
    width: 50%;
    height: 50%;
    margin: auto;
  }
  .el-row--flex {
    align-items: stretch;
  }
}
</style>
